import {
  zoomService
} from "../services/api";
import {
  OAuthCallbackPage
} from "./pairing/OAuthCallbackPage";

export function ZoomCallbackPage() {
  return (
    <OAuthCallbackPage
      providerName="Zoom"
      successType="ZOOM_OAUTH_SUCCESS"
      errorType="ZOOM_OAUTH_ERROR"
      spinnerColorClass="border-blue-600"
      handleCallback={zoomService.handleCallback}
      showSuccessScreen={true}
      popupSuccessCloseDelayMs={2000}
      navigateDelayOnSuccessMs={2000}
    />
  );
}
